/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { i as isWeb, a as isKuaiShouMiniProgram, b as isWeChatMiniProgram, c as isByteDanceMicroApp, d as isMiniApp, e as isBaiduSmartProgram } from '../../../index-892d8eee.js';

function isUndef(type) {
  return type === 'undefined';
}

var isDingdingMiniapp = !isUndef(typeof dd) && dd !== null && !isUndef(typeof dd.alert);

var CONTAINER_NAME = {
  WECHAT: 'wechatMiniProgram',
  ALIPAY: 'aliMiniApp',
  BYTE: 'bytedanceMicroApp',
  WEB: 'web',
  BAIDU: 'baiduSmartProgram',
  KWAI: 'kuaishouMiniProgram'
};

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function promisify(api) {
  return function (arg) {
    return new Promise(function (resolve, reject) {
      var promisifyArg = arg;
      api(_extends$7({}, promisifyArg, {
        success: function success(res) {
          if (promisifyArg && typeof promisifyArg.success === 'function') {
            promisifyArg.success(res);
          }

          resolve(res);
        },
        onSuccess: function onSuccess(res) {
          if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
            promisifyArg.onSuccess(res);
          }

          resolve(res);
        },
        fail: function fail(res) {
          if (promisifyArg && typeof promisifyArg.fail === 'function') {
            promisifyArg.fail(res);
          }

          reject(res);
        },
        onFail: function onFail(res) {
          if (promisifyArg && typeof promisifyArg.onFail === 'function') {
            promisifyArg.onFail(res);
          }

          reject(res);
        },
        complete: function complete(res) {
          if (promisifyArg && typeof promisifyArg.complete === 'function') {
            promisifyArg.complete(res);
          }
        },
        onComplete: function onComplete(res) {
          if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
            promisifyArg.onComplete(res);
          }
        }
      }));
    });
  };
}

var _excluded = ["_ext"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var styleIn = function styleIn(options, baseName) {
  var _ref = options || {},
      _ref$_ext = _ref._ext,
      _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return _extends$6({}, rest, _ext[baseName] || {});
};

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

/**
 * getLocation返回值格式化
 * @param res
 */
var formatResponse = function formatResponse(res) {
  var result = _extends$5({}, res, {
    latitude: String(res.latitude),
    longitude: String(res.longitude),
    accuracy: String(res.accuracy),
    horizontalAccuracy: String(res.horizontalAccuracy)
  });

  return result;
};

function styleOptions(options) {
  if (options === void 0) {
    options = {};
  }

  return _extends$5({}, options, {
    success: function success(res) {
      options.success && options.success(formatResponse(res));
    },
    complete: function complete(res) {
      options.complete && options.complete(res);
    }
  });
}

function normalizeGetLocation(api, containerName) {
  return function (args) {
    return promisify(api)(styleOptions(styleIn(args, containerName))).then(formatResponse);
  };
}
/**
 * openLocation
 * @param api
 */

function normalizeOpenLocation(api, containerName) {
  return function (args) {
    return promisify(api)(styleIn(args, containerName));
  };
}
/**
 * chooseLocation
 */

function normalizeChooseLocation(api, containerName) {
  return function (args) {
    return promisify(api)(styleIn(args, containerName));
  };
}

var getLocation$b = normalizeGetLocation(function (args) {
  args.resultType = args.resultType || 0;

  if (args != null && args.type && typeof args.type === 'string') {
    args.type = 0;
  }

  if (args != null && args.resultType && typeof args.resultType === 'number' && !isNaN(args.resultType)) {
    args.type = args.resultType;
  }

  return isDingdingMiniapp ? dd.getLocation(args) : my.getLocation(args);
}, CONTAINER_NAME.ALIPAY);
var getLocation$c = getLocation$b;

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var openLocation$5 = normalizeOpenLocation(function (args) {
  var params = _extends$4({}, args, {
    latitude: String(args.latitude),
    longitude: String(args.longitude)
  });

  isDingdingMiniapp ? dd.openLocation(params) : my.openLocation(params);
}, CONTAINER_NAME.ALIPAY);

var chooseLocation$5 = normalizeChooseLocation(function (args) {
  return isDingdingMiniapp ? dd.chooseLocation(args) : my.chooseLocation(args);
}, CONTAINER_NAME.ALIPAY);

var aliMiniAppModule = {
  getLocation: getLocation$c,
  openLocation: openLocation$5,
  chooseLocation: chooseLocation$5
};

var getLocation$9 = normalizeGetLocation(function (args) {
  var _args$success = args.success,
      success = _args$success === void 0 ? function () {} : _args$success,
      _args$fail = args.fail,
      fail = _args$fail === void 0 ? function () {} : _args$fail,
      _args$complete = args.complete,
      complete = _args$complete === void 0 ? function () {} : _args$complete;

  if ('geolocation' in navigator) {
    /* 地理位置服务可用 */
    navigator.geolocation.getCurrentPosition(function (position) {
      success(position.coords);
      complete(position.coords);
    }, function (err) {
      fail(err);
      complete(err);
    });
  } else {
    /* 地理位置服务不可用 */
    var err = {
      code: -1,
      message: '地理位置服务不可用'
    };
    fail(err);
    complete(err);
  }
}, CONTAINER_NAME.WEB);
var getLocation$a = getLocation$9;

var openLocation$4 = normalizeOpenLocation(function () {
  throw new Error('Uni API: openLocation不支持');
}, CONTAINER_NAME.WEB);

var chooseLocation$4 = normalizeChooseLocation(function () {
  throw new Error('@uni/apis: chooseLocation不支持');
}, CONTAINER_NAME.WEB);

var webModule = {
  getLocation: getLocation$a,
  openLocation: openLocation$4,
  chooseLocation: chooseLocation$4
};

var getLocation$7 = normalizeGetLocation(function (args) {
  return wx.getLocation(args);
}, CONTAINER_NAME.WECHAT);
var getLocation$8 = getLocation$7;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var openLocation$3 = normalizeOpenLocation(function (args) {
  return wx.openLocation(_extends$3({}, args, {
    latitude: Number(args.latitude),
    longitude: Number(args.longitude)
  }));
}, CONTAINER_NAME.WECHAT);

var chooseLocation$3 = normalizeChooseLocation(function (args) {
  return wx.chooseLocation(args);
}, CONTAINER_NAME.WECHAT);

var weChatModule = {
  getLocation: getLocation$8,
  openLocation: openLocation$3,
  chooseLocation: chooseLocation$3
};

var getLocation$5 = normalizeGetLocation(function (args) {
  return tt.getLocation(args);
}, CONTAINER_NAME.BYTE);
var getLocation$6 = getLocation$5;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var openLocation$2 = normalizeOpenLocation(function (args) {
  return tt.openLocation(_extends$2({}, args, {
    latitude: Number(args.latitude),
    longitude: Number(args.longitude)
  }));
}, CONTAINER_NAME.BYTE);

var chooseLocation$2 = normalizeChooseLocation(function (args) {
  return tt.chooseLocation(args);
}, CONTAINER_NAME.BYTE);

var bytedanceModule = {
  getLocation: getLocation$6,
  openLocation: openLocation$2,
  chooseLocation: chooseLocation$2
};

var getLocation$3 = normalizeGetLocation(function (args) {
  return swan.getLocation(args);
}, CONTAINER_NAME.BAIDU);
var getLocation$4 = getLocation$3;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var openLocation$1 = normalizeOpenLocation(function (args) {
  return swan.openLocation(_extends$1({}, args, {
    latitude: Number(args.latitude),
    longitude: Number(args.longitude)
  }));
}, CONTAINER_NAME.BAIDU);

var chooseLocation$1 = normalizeChooseLocation(function (args) {
  return swan.chooseLocation(args);
}, CONTAINER_NAME.BAIDU);

var baiDuModule = {
  getLocation: getLocation$4,
  openLocation: openLocation$1,
  chooseLocation: chooseLocation$1
};

var getLocation$1 = normalizeGetLocation(function (args) {
  return ks.getLocation(args);
}, CONTAINER_NAME.KWAI);
var getLocation$2 = getLocation$1;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var openLocation = normalizeOpenLocation(function (args) {
  return ks.openLocation(_extends({}, args, {
    latitude: Number(args.latitude),
    longitude: Number(args.longitude)
  }));
}, CONTAINER_NAME.KWAI);

var chooseLocation = normalizeChooseLocation(function (args) {
  return ks.chooseLocation(args);
}, CONTAINER_NAME.KWAI);

var kuaiShouModule = {
  getLocation: getLocation$2,
  openLocation: openLocation,
  chooseLocation: chooseLocation
};

var getLocation = function getLocation(args) {
  if (isWeb) {
    return webModule.getLocation(args);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.getLocation(args);
  } else if (isWeChatMiniProgram) {
    return weChatModule.getLocation(args);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.getLocation(args);
  } else if (isMiniApp) {
    return aliMiniAppModule.getLocation(args);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.getLocation(args);
  } else {
    throw new Error('Uni API：getLocation暂不支持');
  }
};

var mini = getLocation;

export { mini as default };
